'use client';

import React, { useState, useEffect } from "react";
import { Quicksand } from 'next/font/google';
import LandingHero from "@/components/landing-hero";

import Image from 'next/image';
import '@/app/globals.css';
import ConversationPreview from './components/landing/ConversationPreview';
import Footer from './components/landing/Footer';
import TopicsFeatureCard from './components/landing/TopicsFeatureCard';
import { ModalProvider } from './context/ModalContext';

const quicksand = Quicksand({ subsets: ['latin'], weight: ['300'] });

const LandingPageContent: React.FC = () => {
  const [isLoading, setIsLoading] = useState(true);
  const isDevComplete = true;

  useEffect(() => {
    // Reduce loading time for better UX
    const timer = setTimeout(() => setIsLoading(false), 500);
    return () => clearTimeout(timer);
  }, []);

  return (
    <ModalProvider>
      {isLoading && (
        <div className="fixed inset-0 bg-black z-50 flex items-center justify-center">
          <Image
            src="/logo.png"
            alt="Logo"
            style={{ objectFit: 'cover' }}
            width={350}
            height={350}
            className="animate-pulse"
          />
        </div>
      )}
      <div className={`${quicksand.className} min-h-screen overflow-x-hidden bg-black text-gray-300 ${isLoading ? 'opacity-0' : 'opacity-100 transition-opacity duration-500'}`}>
        <div className="relative min-h-screen">
          <LandingHero isDevComplete={isDevComplete} />
          
          <ConversationPreview />
          <TopicsFeatureCard />
          <Footer />
        </div>
      </div>
    </ModalProvider>
  );
};

const LandingPage: React.FC = () => {
  return <LandingPageContent />;
};

export default LandingPage;
